import Component from "@lib/Component.js";

export default class Findseller extends Component {
  init() {
    super.init();

    this.refs.input = this.refs.form.querySelector("input");
    this.refs.btemail = this.el.querySelector(".findseller-article-bt a");
    this.refs.image = this.el.querySelector(".findseller-article-image img");

    this.addListeners();
  }

  addListeners() {
    this.refs.form.addEventListener("submit", this);
    this.refs.btclose.addEventListener("click", this);
  }

  handleEvent(event) {
    if (event.type === "submit") {
      this.onSubmit(event);
    }
    if (event.type === "click") {
      this.onClickClose(event);
    }
  }

  onClickClose() {
    this.refs.article.classList.add("hide");
    this.refs.input.value = "";
  }

  onSubmit(event) {
    event.preventDefault();

    const zipcode = this.refs.input.value;
    const url = this.refs.form.getAttribute("action") + zipcode;

    this.refs.article.classList.add("hide");
    this.refs.noresult.classList.add("hide");

    fetch(url)
      .then((response) => response.json())
      .then((rs) => {
        if (rs.status == 1) {
          // console.info(rs);
          this.refs.name.innerHTML = rs.seller.lastname + " " + rs.seller.firstname;
          this.refs.title.innerHTML = rs.seller.title;
          this.refs.phone.innerHTML = rs.seller.phone;
          this.refs.phonelink.href = "tel:" + rs.seller.phone.replace(/ /g, "");
          this.refs.btemail.href = "mailto:" + rs.seller.email;

          this.refs.image.onload = () => {
            this.refs.article.classList.remove("hide");
          };
          this.refs.image.src = rs.seller.image.source;
          this.refs.image.alt = rs.seller.image.alt;
        } else {
          this.refs.article.classList.add("hide");
          this.refs.noresult.classList.remove("hide");
        }
      });

    return false;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Findseller.js